/**
 * Incoming booking-request card — shown in My Rides › Requests and in the
 * archive. Tapping opens the booking detail.
 */
import type { BookingDto } from '@waylo/shared';
import { useT } from '../lib/i18n';
import { Card } from './Card';
import { Badge } from './Badge';

export function RequestCard({
  booking: b,
  onOpen,
}: {
  booking: BookingDto;
  onOpen: () => void;
}): JSX.Element {
  const { t } = useT();
  return (
    <Card onClick={onOpen} className="space-y-2">
      <div className="flex items-center justify-between">
        <p className="font-semibold text-tg-text">{b.passenger.displayName}</p>
        <Badge
          tone={
            b.status === 'pending'
              ? 'warning'
              : b.status === 'approved'
                ? 'success'
                : b.status === 'declined' || b.status.startsWith('cancelled')
                  ? 'danger'
                  : 'neutral'
          }
        >
          {t(`bs.${b.status}` as 'bs.pending')}
        </Badge>
      </div>
      <p className="text-sm text-tg-hint">
        {b.seats} {b.seats === 1 ? t('common.seat_one') : t('common.seat_other')}
        {b.messageToDriver && ` · "${b.messageToDriver.slice(0, 80)}"`}
      </p>
      {b.companions && b.companions.length > 0 && (
        <p className="text-sm text-tg-hint">
          {t('booking.companions')}: {b.companions.join(', ')}
        </p>
      )}
    </Card>
  );
}
